import { defHttp } from '/@/utils/http/axios';
import { LoginParams, GetUserInfoModel } from './model/userModel';

import { ErrorMessageMode } from '/#/axios';

import { Base64 } from 'js-base64';

enum Api {
  Login = '/account/login',
  Logout = '/oauth/logOut',
  GetUserInfo = '/getUserInfo',
  GetPermCode = '/getPermCode',
  TestRetry = '/testRetry',
  LogOut = '/account/logout',
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  const str = params.username + ':' + params.password;
  const base64 = Base64.encode(str);
  return defHttp.post<any>(
    {
      url: Api.Login,
      headers: {
        Authorization: 'Basic ' + base64,
      },
    },
    {
      errorMessageMode: mode,
    },
  );
}

// /**
//  * @description: user login api
//  */
// export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
//   console.log('[ params ] >', params);
//   return defHttp.post<any>(
//     {
//       url: Api.Login,
//       data: params,
//     },
//     {
//       errorMessageMode: mode,
//     },
//   );
// }

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<GetUserInfoModel>({ url: Api.GetUserInfo }, { errorMessageMode: 'none' });
}

export function getPermCode() {
  return defHttp.get<string[]>({ url: Api.GetPermCode });
}

export function LogoutApi() {
  return defHttp.get({ url: Api.LogOut });
}

export function doLogout() {
  return defHttp.post({ url: Api.Logout });
}

export function testRetry() {
  return defHttp.get(
    { url: Api.TestRetry },
    {
      retryRequest: {
        isOpenRetry: true,
        count: 5,
        waitTime: 1000,
      },
    },
  );
}
